<template>
   <div>
       <div class="fRight">产品名称：
            <el-select v-model="roomType" placeholder="请选择" size="small" @change="selectList" v-if="brand">
                <el-option v-for="(item,index) in AdminDataLists.lists" :key="index" :label="item.name" :value="item.id" />
            </el-select>
            <el-select v-model="roomType" placeholder="请选择" size="small" @change="selectList" v-else>
                <el-option v-for="(item,index) in AdminDataLists.lists" :key="index" :label="item.title" :value="item.id" />
            </el-select>
       </div>
       <div class="bg-white d-center-between pt-3 pb-3 w-100">
            <i class="iconfont icon-jiantou-copy cursor-pointer" @click="updateDayList(-1)"
            :class="{'disabled-arrow':!leftArrow}"></i>
            <h4>{{yearMonth}}</h4>
            <i class="iconfont icon-jiantou cursor-pointer" @click="updateDayList(1)"></i>
        </div>
        <div class="bg-dark text-warning d-center-around w-100">
            <div v-for="item in weekDays" class="w-25 p-1" :class="{'weekend':item === '五' || item === '六'}" :key="item">{{item}}</div>
        </div>
        <div class="bg-white d-center-start pl-2 pr-2 w-100" v-for="(item,index) in days" :key="index">
            <div class="day-price" :class="{'disabled':!child || child.disabled,'bg-orange': child.id}"
                v-for="(child,index) in item" :key="index" @click="changeDatePrice(child)">
                <p class="mb-1" v-show="child.day">{{child.day}}号</p>
                <p>{{brand ? '市价' : '原价'}}：&yen;{{child.price1 ? child.price1 : '-'}}</p>
                <p>{{brand ? '旅价' : '抢购'}}：&yen;{{child.price2 ? child.price2 : '-'}}</p>
                <p>结算：&yen;{{child.price3 ? child.price3 : '-'}}</p>
            </div>
        </div>
        <!-- <div v-if="AdminDataLists.lists.length > 0"> -->
            <el-dialog :title="`修改${currentDate.date}日`" :visible.sync="changeDatePriceFlag" center>
                <div class="d-flex flex-column align-items-center">
                    <left-text-border class="mb-3 w-50" :leftText="brand ? '市价' :'原价'" v-model="currentDate.price1"/>
                    <left-text-border class="mb-3 w-50" :leftText="brand ? '旅价' :'抢购价'" v-model="currentDate.price2"/>
                    <left-text-border class="mb-3 w-50" leftText="结算价" v-model="currentDate.price3"/>
                </div>
                <span slot="footer">
                    <el-button @click="changeDatePriceFlag = false">取 消</el-button>
                    <el-button type="primary" @click="ensureChange">确 定</el-button>
                </span>
            </el-dialog>
        <!-- </div> -->
   </div>
</template>

<script>
    import {mapState,mapGetters,mapActions} from 'vuex'
    export default {
        name: 'proCalendar',
        data() {
            return {
                roomType: '',
                year: new Date().getFullYear(),
                month: new Date().getMonth() + 1,
                days:[],
                weekDays:['日','一','二','三','四','五','六'],
                pickedDay: '',
                currentDate: {},   //点击设置特殊价格的当前项
                leftArrow: false,
                changeDatePriceFlag: false,
                date_in: '',
                date_out: ''
            }
        },
        computed: {
            ...mapState(['StoreCalendar','AdminDataLists']),
            ...mapGetters(['brand','storeInfo']),
            yearMonth() {
                return `${this.year}-${this.month < 10 ? '0' + this.month : this.month}`;
            }
        },
        created() {
            //获取产品名称列表
            this.getDataLists();
        },
        watch: {
            /*改变房型时同步客房日历*/
            roomType() { this.getCalendar()},
            //改变日期时间时同步客房日历
            yearMonth() { this.getCalendar(); },
            //对获取的日历进行处理
            StoreCalendar(newVal) {
                this.days = this.StoreCalendar.map(v => {
                v.forEach(t => {
                    if (t) {
                        let today = new Date().getTime();
                        let tDay = Date.parse(new Date(`${this.yearMonth}-${t.day} 17:00:00`));
                        t.disabled = (tDay < today) || (tDay > this.date_out) || (tDay < this.date_in)
                    }
                })
                return v
                })
            }
        },
        methods: {
            ...mapActions(['getStoreCalendar','getAdminDataLists','setStoreCalendar']),
            //选择不同的套餐获取购买时间范围
            selectList (id) {
                let times = this.AdminDataLists.lists.filter(item => item.id == id )[0]
                this.date_in = this.brand ? times.start_time * 1000 : times.date_in * 1000
                this.date_out = this.brand ? times.end_time * 1000 : times.date_out * 1000
            },
            //获取产品名称列表
            getDataLists() {
                let data = {main_id: this.$route.query.mainId, status:''}
                if (this.brand) data = {
                    store_id: this.storeInfo.storeId,
                    store_type: this.storeInfo.type,
                    itinerary_id: this.$route.query.discount
                }
                this.getAdminDataLists({ type:'productList', data, successFun: () => {
                    this.roomType = this.AdminDataLists.lists[0].id
                    this.date_in = this.brand ? this.AdminDataLists.lists[0].start_time * 1000 : this.AdminDataLists.lists[0].date_in * 1000
                    this.date_out = this.brand ? this.AdminDataLists.lists[0].end_time * 1000 : this.AdminDataLists.lists[0].date_out * 1000
                    this.getCalendar()
                }});
            },
            /*获取客房日历*/
            getCalendar() {
                //默认获取第一个房型的价格日历
                this.getStoreCalendar({
                    store_id: this.brand ? this.storeInfo.storeId :this.roomType,
                    store_type: this.brand ? '8' : '7',
                    room_id: this.roomType,
                    year_day:this.yearMonth,
                });
            },
            /*点击后更新日期列表*/
            updateDayList(index) {
                //当不显示左箭头还减少当前月时，不作处理，直接返回
                if (!this.leftArrow && index < 0) return;
                this.month += index;
                if (this.month <= 0) {
                    this.month = 12;
                    this.year--;
                }
                if (this.month > 12) {
                    this.month = 1;
                    this.year++;
                }
                let today = new Date();
                if (this.year > today.getFullYear()) this.leftArrow = true;
                if (this.year === today.getFullYear()) this.leftArrow = this.month > today.getMonth() + 1;
                this.getCalendar();
            },
            /*提交修改数据*/
            changeDatePrice(item) {
                if (!item || item.disabled) return;
                this.changeDatePriceFlag = true;
                this.currentDate = {
                    price1: item.price1,
                    price2: item.price2,
                    price3: item.price3,
                    total: item.total_1,
                    roomcal_id: item.id,
                    date:`${this.month < 10 ? '0' + this.month : this.month}-${item.day < 10 ? '0' + item.day : item.day}`
                }
            },
            /*提交修改价格表单*/
            ensureChange() {
                if (!this.$GFUN.powerIsInArray([194,464,568])) { this._alert('您没有相关权限！',null,'error'); return; }
                this.setStoreCalendar({
                    data:{
                        store_id: this.brand ? this.storeInfo.storeId : this.roomType,
                        store_type: this.brand ? '8' : '7',
                        room_id:this.roomType,
                        ...this.currentDate
                    },
                    successFun: () => {
                        this.changeDatePriceFlag = false;
                        this.getCalendar();
                    }
                })
            },
            /*添加房型*/
            goAddRoom() {
                let query = {step:'3',storeId:this.$route.query.storeId}
                this.$router.push({name:'RoomMeetManage',query})
            }
        },
    }
</script>

<style lang="scss" scoped>
  .fRight{
    float:right;
    margin-top: -40px;
    margin-right: 0
  }
  .disabled-arrow{
    color: #fff;
    cursor: default;
  }
  .weekend{
    background: #fdb900;
    color: #000;
  }
  .bg-white{
    .day-price:last-child{
      margin-right: 0%
    }
  }
  .day-price{
    width: 13%;
    height: 100px;
    margin: 10px 0;
    margin-right: 1.5%;
    padding: 10px;
    text-align: left;
    cursor: pointer;
    border-radius: 5px;
    border: 1px solid #eee;
    box-sizing: border-box;
    &:hover{
      background: #eee;
    }
    &.disabled{
      background: #eee;
      cursor: default;
      color: #919191;
      border-radius: 0
    }
  }
  .bg-orange{
      background-color: #e7d9be;
      color: #fff
  }
</style>
